import { render, staticRenderFns } from "./DashboardWidgetTurnoverAttivita.vue?vue&type=template&id=6d0c17e2&"
import script from "./DashboardWidgetTurnoverAttivita.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetTurnoverAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports